<template>
  <div>
    <div class="mb-12">
      <div class="page-title mb-2">
        แบบฟอร์มความต้องการเทคโนโลยี
        <span class="page-end-title">(Requirement Form)</span>
      </div>

      <StatusStep
        :current-step="currentStep"
        :steps="documentSteps"
        @onClick="jumpStep"
      ></StatusStep>
    </div>

    <!--  Form switcher  -->
    <div>
      <FormGeneral
        :masterData="masterData"
        :form-data="formGeneral"
        v-if="currentStep == 1"
      ></FormGeneral>
      <FormBusiness
        :masterData="masterData"
        :form-data="formBusiness"
        v-if="currentStep == 2"
      ></FormBusiness>
      <FormIssuesAndNeeds
        :masterData="masterData"
        :form-data="formIssuesAndNeeds"
        v-if="currentStep == 3"
      ></FormIssuesAndNeeds>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="$router.push({ name: 'RequirementList' })"
        >ยกเลิก</Button
      >

      <div class="flex-center">
        <div v-if="currentStep == 1">
        </div>
        <div v-else>
              <Button
          theme="3"
          min-width="120px"
          :masterData="masterData"
          @onClick="backForm"
          :disabled="isLoading"
          >&lt; ย้อนกลับ</Button
        >
        </div>
    
        <Button
          theme="4"
          min-width="120px"
          :masterData="masterData"
          :disabled="isLoading"
          @onClick="saveDraft"
          >บันทึกฉบับร่าง</Button
        >
        <Button
          theme="3"
          min-width="120px"
          :disabled="isLoading"
          :masterData="masterData"
          @onClick="nextForm"
          >ถัดไป ></Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep";
import Button from "../../components/input/Button";

import FormGeneral from "./FormGeneral";
import FormBusiness from "./FormBusiness";
import FormIssuesAndNeeds from "./FormIssuesAndNeeds";
import {eventBus, validateEmail} from "../../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "RequirementForm",
  components: {
    StatusStep,
    Button,
    FormGeneral,
    FormBusiness,
    FormIssuesAndNeeds,
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
    }),
  },
  data() {
    return {
      currentStep: 1,
      documentSteps: [
        {
          no: 1,
          name: "ข้อมูลทั่วไป",
        },
        {
          no: 2,
          name: "ข้อมูลการประกอบการ",
        },
        {
          no: 3,
          name: "ประเด็นปัญหาและความต้องการ",
        },
      ],
      formGeneral: {},
      formBusiness: {},
      formIssuesAndNeeds: {},
      draftId: null,
      masterData: {},
    };
  },
  watch: {
    currentStep(newValue, oldValue) {
      console.log("currentStep: ", newValue, oldValue);
      if (newValue < oldValue) {
        this.retrieveForms();
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.retrieveForms();
    } else {
      this.createForm();
    }

    eventBus.$on("requirementFormGeneralSend", (form) => {
      this.formGeneral = form;
      console.log("FormGeneral data: ", this.formGeneral);
    });

    eventBus.$on("requirementFormBusinessSend", (form) => {
      this.formBusiness = form;
      console.log("FormBusiness data: ", this.formBusiness);
    });

    eventBus.$on("requirementFormIssuesAndNeedsSend", (form) => {
      this.formIssuesAndNeeds = form;
      console.log("FormIssuesAndNeeds data: ", this.formIssuesAndNeeds);
    });
  },
  methods: {
    jumpStep(step) {
      if (step == this.currentStep) return;
      if (this.isLoading) {
        this.$store.commit("General/setModal", {
          title: "Wait a moment.",
          text: "Preparing data please wait...",
          theme: "warning",
          showCancel: false,
          buttonText: "OK",
        });
        return;
      }
      if (this.$route.query.id || this.draftId) {
        this.currentStep = parseInt(step);
        this.$vuetify.goTo("#app");
        this.doNotSubmit = false;
      } else {
        this.$store.commit("General/setModal", {
          title: "Complete this step first!",
          text: "Complete the first step then you can jump",
          theme: "error",
          showCancel: false,
          buttonText: "OK",
        });
      }
    },
    backForm() {
      if (this.currentStep <= 1) return;
      const res = this.saveDraft();
      if (res) {
        this.currentStep -= 1;
        // ถ้ามี draftId แล้ว ให้ push route ไปที่ edit
        if (this.draftId) {
          return this.$router.push("/requirement-form/" + this.draftId);
        }
        this.$vuetify.goTo("#app");
      }
    },
    async nextForm() {
      if (this.currentStep >= this.documentSteps.length) {
        const res = await this.saveDraft();
        if (res) {
          return this.$router.push({
            name: "RequirementPreview",
            params: { id: this.draftId },
          });
        }
      } else {
        const res2 = await this.saveDraft();
        if (res2) {
          this.currentStep += 1;
          // router replace เติม query ไปด้วย
          if (this.draftId) {
            return this.$router.push("/requirement-form/" + this.draftId);
          }
          this.$vuetify.goTo("#app");
        }
      }
    },
    async saveDraft() {
      this.requestForm(this.currentStep);

      // validate formGeneral
      // if (this.currentStep == 1) {
      //   if ((this.formGeneral.p1_pid && this.formGeneral.p1_pid.length != 13) ||
      //       (this.formGeneral.p1_addr_postcode && this.formGeneral.p1_addr_postcode.length != 5) ||
      //       (this.formGeneral.p1_mobile_phone) ||
      //       (this.formGeneral.p1_email && !validateEmail(this.formGeneral.p1_email)) ||
      //       (this.formGeneral.p1_website && !/^(http|https):\/\/[^ "]+$/.test(this.formGeneral.p1_website)) ||
      //       (this.formGeneral.p1_org_postcode && this.formGeneral.p1_org_postcode.length != 5) ||
      //       (this.formGeneral.p1_org_mobile_phone) ||
      //       (this.formGeneral.p1_org_email && !validateEmail(this.formGeneral.p1_org_email)) ||
      //       (this.formGeneral.p1_org_website && !/^(http|https):\/\/[^ "]+$/.test(this.formGeneral.p1_org_website))
      //   ) {
      //     this.$store.commit("General/setModal", {
      //       title: "ข้อมูลไม่ถูกต้อง",
      //       text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //       theme: "error",
      //       showCancel: false,
      //       buttonText: "OK",
      //     });
      //     return false;
      //   }
      // }

      //convert this.formIssuesAndNeeds.p3_issue_and_req to string if it's an array
      if (Array.isArray(this.formIssuesAndNeeds.p3_issue_and_req)) {
        //if array has null value, remove it
        this.formIssuesAndNeeds.p3_issue_and_req =
          this.formIssuesAndNeeds.p3_issue_and_req.filter(function (el) {
            return el != null;
          });

        this.formIssuesAndNeeds.p3_issue_and_req = JSON.stringify(
          this.formIssuesAndNeeds.p3_issue_and_req
        );
      }

      if (Array.isArray(this.formGeneral.p1_personal_status)) {
        this.formGeneral.p1_personal_status = JSON.stringify(
          this.formGeneral.p1_personal_status
        );
      }

      //get today date Y-m-d
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;

      let payload = {
        ...this.formGeneral,
        ...this.formBusiness,
        ...this.formIssuesAndNeeds,
        // doc_no: '0001', // require field
        doc_status: "Draft", // require field
        year: this.masterData.fiscal_year,
        doc_date: today,
      };
      // Add the ID to the payload if it exists
      if (this.draftId) {
        payload.id = this.draftId;
      }

      console.log("payload: ", payload);
      let res = null;
      // Check if the form has an ID
      if (payload.id) {
        try {
          console.log("update draft");
          res = await this.updateDraft(payload);
        } catch (error) {
          this.$store.commit('General/setModal', {
            title: 'Error',
            text: error.message,
            theme: "error",
            showCancel: false,
            buttonText: 'OK'
          })
          return
        }

      } else {
        try {
          console.log("save draft");
          res = await this.$apiFire("Requirement/saveRequirementForm", payload);
          // Update the form's ID after saving
          this.draftId = res.id;
        } catch (error) {
          this.$store.commit('General/setModal', {
            title: 'Error',
            text: error.message,
            theme: "error",
            showCancel: false,
            buttonText: 'OK'
          })
          return
        }
      }

      //convert this.formIssuesAndNeeds.p3_issue_and_req back to array if it's a string
      if (typeof this.formIssuesAndNeeds.p3_issue_and_req === "string") {
        this.formIssuesAndNeeds.p3_issue_and_req = JSON.parse(
          this.formIssuesAndNeeds.p3_issue_and_req
        );
      }

      if (typeof this.formGeneral.p1_personal_status === "string") {
        this.formGeneral.p1_personal_status = JSON.parse(
          this.formGeneral.p1_personal_status
        );
      }

      // eslint-disable-next-line no-prototype-builtins
      return typeof res === "object" && res.hasOwnProperty("id");
    },

    async updateDraft(payload) {
      let res = await this.$apiFire(
        "Requirement/updateRequirementForm",
        payload
      );
      console.log(res);
      return res;
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("requirementFormGeneral");
          break;

        case 2:
          eventBus.$emit("requirementFormBusiness");
          break;

        case 3:
          eventBus.$emit("requirementFormIssuesAndNeeds");
          break;
      }
    },
    async createForm() {
      let res = await this.$apiFire("Requirement/createRequirementForm");
      console.log(res);
      if (res) {
        this.masterData = res;
      }
    },
    retrieveForms() {
      // Retrieve the form data
      this.$apiFire("Requirement/getRequirementFormById", {
        id: this.$route.params.id,
      }).then((res) => {
        console.log("getRequirementFormById: ", res);
        if (res) {
          this.masterData = res.masterData;
          this.draftId = res.requirementForm.id;

          //set this.formGeneral = res.requirementForm's object name start with p1_
          this.formGeneral = Object.keys(res.requirementForm).reduce(
            (obj, key) => {
              if (key === "doc_no") {
                obj[key] = res.requirementForm[key];
              }
              if (key === "doc_date") {
                //convert doc_date from Y-m-d to d/m/Y
                let date = new Date(res.requirementForm[key]);
                let dd = String(date.getDate()).padStart(2, "0");
                let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
                let yyyy = date.getFullYear();
                date = dd + "/" + mm + "/" + yyyy;
                obj[key] = date;
              }
              if (key.startsWith("p1_")) {
                obj[key] = res.requirementForm[key];
              }
              return obj;
            },
            {}
          );
          //convert this.formGeneral.p1_personal_status back to array if it's a string
          if (
            this.formGeneral.p1_personal_status &&
            typeof this.formGeneral.p1_personal_status === "string"
          ) {
            this.formGeneral.p1_personal_status = JSON.parse(
              this.formGeneral.p1_personal_status
            );
          }

          //set this.formBusiness = res.requirementForm's object name start with p2_
          this.formBusiness = Object.keys(res.requirementForm).reduce(
            (obj, key) => {
              if (key.startsWith("p2_")) {
                obj[key] = res.requirementForm[key];
              }
              return obj;
            },
            {}
          );

          //set this.formIssuesAndNeeds = res.requirementForm's object name start with p3_
          this.formIssuesAndNeeds = Object.keys(res.requirementForm).reduce(
            (obj, key) => {
              if (key.startsWith("p3_")) {
                obj[key] = res.requirementForm[key];
              }
              return obj;
            },
            {}
          );
        }
      });
      // General form
      eventBus.$on("requirementFormGeneralSend", (form) => {
        this.formGeneral = form;
        // clear org data on same address case
        if (form.p1_same_addr) {
          this.formGeneral.p1_org_addr = undefined;
          this.formGeneral.p1_org_pid = undefined;
          this.formGeneral.p1_org_did = undefined;
          this.formGeneral.p1_org_sdid = undefined;
          this.formGeneral.p1_org_postcode = undefined;
          this.formGeneral.p1_org_phone = undefined;
          this.formGeneral.p1_org_mobile_phone = undefined;
          this.formGeneral.p1_org_fax = undefined;
          this.formGeneral.p1_org_email = undefined;
          this.formGeneral.p1_org_website = undefined;
        }
        // keep in storage
        this.$store.commit("Requirement/setGeneralForm", this.formGeneral);
      });

      // Business form
      eventBus.$on("requirementFormBusinessSend", (form) => {
        this.formBusiness = form;
        // keep in storage
        this.$store.commit("Requirement/setBusinessForm", this.formBusiness);
      });

      // IssuesAndNeeds form
      eventBus.$on("requirementFormIssuesAndNeedsSend", (form) => {
        this.formIssuesAndNeeds = form;
        // keep in storage
        this.$store.commit(
          "Requirement/setIssuesAndNeedsForm",
          this.formIssuesAndNeeds
        );
      });
    },
  },
  beforeDestroy() {
    eventBus.$off("requirementFormGeneralSend");
    eventBus.$off("requirementFormBusinessSend");
    eventBus.$off("requirementFormIssuesAndNeedsSend");
  },
};
</script>

<style scoped></style>
